import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AspCartService } from '../asp-cart/asp-cart.service';
import { AspLoadingService } from '../asp-loading/asp-loading.service';
import { GlobalVariable } from 'app/main/globals';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-asp-share-cart',
  templateUrl: './asp-share-cart.component.html',
  styleUrls: ['./asp-share-cart.component.scss']
})
export class AspShareCartComponent implements OnInit {
  showSharedWtemPopup = false;
  @Input() cartItems: any[] = [];
  @Input() sharedCartKey: string = '';
  @Output() close = new EventEmitter<void>();
  cartList: any;

  constructor(
    private aspCartService: AspCartService,
    private aspLoadingService: AspLoadingService,
    private router: Router,
    private toastr: ToastrService, 
  ) { }

  ngOnInit(): void {
  }

  closeSharedWtemPopup() {
    const cartKey = this.sharedCartKey;
    const payload = { cartKey };

    this.aspCartService.updateCartDetails(payload).subscribe(
      (response: any) => {
        console.log('✅ Cart updated successfully on cancel:', response);
        // After API completes, tell parent to close
        this.close.emit();
      },
      error => {
        this.toastr.error('Failed to update cart on cancel', 'Share Cart');
        this.close.emit();
      }
    );
  }


  shareCartViaWhatsApp() {
    this.aspLoadingService.show();
    const garageName = (localStorage.getItem('spareSelectedGarageName') || 'Our Garage').trim();
    const vehicleName = localStorage.getItem('selectedVehicleName') || 'Vehicle';
    const garageKey = localStorage.getItem('garageKey') || '';
    const userKey = localStorage.getItem('spareUserKey') || '';
    const registrationNumber = localStorage.getItem('selectedRegistrationNumber') || '';

    if (!this.cartList || this.cartList.length === 0) {
      console.warn('Cart is empty.');
      return;
    }

    const payload = this.cartList.map(item => ({
      partKey: item.part_key || item.partKey || '',
      rowKey: item.row_key || item.rowKey || '',
      partNumber: item.partNumber || '',
      name: item.name || '',
      brandKey: item.brandKey || '',
      brandName: item.brandName || '',
      brandDescription: item.brandDescription || '',
      cartQty: item.cart_qty || item.cartQty || 1,
      category: item.category || '',
      customerBoughtCount: item.customerBoughtCount || 0,
      deliveryStatus: item.deliveryStatus || '',
      deliveryTime: item.deliveryTime || '',
      description: item.description || null,
      discount: item.discount || 0,
      discountType: item.discountType || null,
      hsn: item.hsn || '',
      imageUrl: item.imageUrl || '',
      itemId: item.itemId || '',
      garageCount: item.garageCount || 0,
      orderedCount: item.orderedCount || 0,
      previouslyBought: item.previouslyBought || false,
      mrp: item.mrp || 0,
      partType: item.partType || '',
      plannedSku: item.plannedSku || 0,
      quantity: item.quantity || 0,
      registrationNumber: registrationNumber,
      selectedFuel: item.selectedFuel || '',
      selectedMake: item.selectedMake || '',
      selectedModel: item.selectedModel || '',
      selectedYear: item.selectedYear || '',
      sellingPrice: item.sellingPrice || 0,
      soldQuantity: item.soldQuantity || 0,
      discountAmount: item.discountAmount || 0,
      subCategory: item.subCategory || '',
      tag: item.tag || '',
      unit: item.unit || 0,
      unitType: item.unitType || '',
      variant: item.variant || '',
      variantKey: item.variantKey || '',
      garageKey: garageKey,
      userKey: userKey
    }));

    this.aspLoadingService.show();
    this.aspCartService.createCart(payload).subscribe(
        (response: any) => {
          this.aspLoadingService.hide();
          const cartKey = response?.data?.[0]?.cartKey;
          if (!cartKey) {
            console.error('Cart key missing in response');
            return;
          }
          
      const shareCartUrl = `${GlobalVariable.AUTOVERSE_WEB}/cart?cartKey=${cartKey}`;

          const message =
            `Hello ${garageName}! 👋\n\n` +
            `🚗🔧 Find the Perfect ${vehicleName} Parts List!\n\n` +
            `Upgrade your customer's rides with precision.\n\n` +
            `Tap to explore now 👉 🛠\n${shareCartUrl}`;

          const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
          window.open(whatsappUrl, '_blank');
        },
        error => {
          this.toastr.error('Error creating cart', 'Share Cart');
        }
    );
  }

  addSharedCartToLocalCart() {
    this.aspLoadingService.show();
    this.showSharedWtemPopup = true;

    const cartKey = this.sharedCartKey

    this.cartList = [];
    let newData = {};
    newData = JSON.parse(localStorage.getItem('addedCart'))?.[0] || {};

    if (this.cartItems && this.cartItems.length > 0) {
      this.cartItems.forEach(item => {
        const key = item.partKey && item.partKey.trim() ? item.partKey : item.itemId;

        newData[key] = {
          key: key,
          partNumber: item.partNumber,
          name: item.name,
          brand: {
            key: item.brandKey || '',
            name: item.brandName || '',
            description: item.brandDescription || '',
          },
          cart_qty: item.cartQty || 1,
          category: item.category,
          customerBoughtCount: item.customerBoughtCount,
          deliveryStatus: item.deliveryStatus,
          deliveryTime: item.deliveryTime,
          description: item.description,
          discount: item.discount,
          discountType: item.discountType,
          hsn: item.hsn,
          imageUrl: item.imageUrl,
          itemId: item.itemId,
          itemSummary: {
            partNumber: item.partNumber,
            previouslyBought: item.previouslyBought,
            orderedCount: item.orderedCount,
            garageCount: item.garageCount
          },
          garageCount: item.garageCount,
          orderedCount: item.orderedCount,
          previouslyBought: item.previouslyBought,
          mrp: item.mrp,
          partType: item.partType,
          plannedSku: item.plannedSku,
          quantity: item.quantity,
          registrationNumber: item.registrationNumber,
          rowKey: item.rowKey,
          selectedFuel: item.selectedFuel,
          selectedMake: item.selectedMake,
          selectedModel: item.selectedModel,
          selectedYear: item.selectedYear,
          sellingPrice: item.sellingPrice,
          soldQuantity: item.soldQuantity,
          spareStocks: {
            partNumber: item.partNumber,
            quantity: item.quantity,
            mrp: item.mrp,
            sellingPrice: item.sellingPrice,
            discountType: item.discountType,
            discountAmount: item.discount
          },
          discountAmount: item.discount,
          subCategory: item.subCategory,
          tag: item.tag,
          unit: item.unit,
          unitType: item.unitType,
          variant: item.variant,
          variantKey: item.variantKey
        };
      });

      this.cartList.push(newData);
      localStorage.setItem('addedCart', JSON.stringify(this.cartList));
    }

    // Update cart details via API
    const payload = { cartKey };

    this.aspCartService.updateCartDetails(payload).subscribe(
      (response: any) => {
        console.log('✅ Cart updated successfully:', response);
        this.aspLoadingService.hide();
        this.close.emit();
        this.router.navigate(['/cart']);
      },
      error => {
        this.toastr.error('Failed to update cart', 'Add to cart');
        this.aspLoadingService.hide();
      }
    );
  }

}
 